import {
  Box, Button, Divider, Typography,
} from '@mui/material';
import Cart from 'components/Cart';
import CateringProvider from 'components/CateringProvider';
import { CartContext } from 'constants/contexts';
import React, { useContext } from 'react';
import { env } from 'constants';
import OrderDetails from './OrderDetails';

function Sidebar({ schedulingRequired, setSchedulingOpen }) {
  const cart = useContext(CartContext);
  const catering = CateringProvider.useCatering();

  return (
    <Box sx={{
      height: '100vh', display: 'flex', flexDirection: 'column', my: 3, mr: 4, borderRadius: 4, border: '1px solid', borderColor: 'border.default',
    }}
    >
      {
        env.IS_CATERING && (
          <OrderDetails />
        )
      }
      {cart.items?.length > 0 && !env.IS_CATERING && (
        <>
          <Box p={3}>
            <Cart.Header />
          </Box>
          <Divider />
        </>
      )}
      <Box sx={{
        overflowY: 'auto',
        flex: 1,
        mb: 2,
        p: 2,
      }}
      >
        <Cart.Items />
      </Box>
      {/* {
        catering.rewardMessages?.cart ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            px={2}
            py={0.5}
            bgcolor="success.surface"
          >
            <Typography
              variant="title-sm"
              color="success.darker"
              textAlign="center"
            >
              {catering.rewardMessages?.cart}
            </Typography>
          </Box>
        ) : (cart.items?.length > 0 && <Divider />)
      } */}

      <Box p={2} pt="10px">

        {
          schedulingRequired ? (
            <Button variant="contained" size="large" fullWidth onClick={() => setSchedulingOpen(true)}>
              Schedule for later
            </Button>
          ) : (
            <Cart.Action />
          )
        }
      </Box>

    </Box>
  );
}
export default Sidebar;
